import {FilterLineupsByTeamCombinationsInterface} from './filter-lineups-by-team-combinations-interface';

export function getFilteredLineupsByTeamCombinations(
    lineups,
    filterLineupsByTeamCombinations: FilterLineupsByTeamCombinationsInterface,
) {
    if (!filterLineupsByTeamCombinations.hasCheckedCombinations()) {
        return Object.values(lineups.all());
    }

    const lineupIds = filterLineupsByTeamCombinations.getLineupIds();

    return lineupIds.map((lineupId) => lineups.getLineup(lineupId)).filter((lineup) => lineup !== null);
}
